import { Box, Button, Card, CardHeader, CardBody, Heading, Text, VStack } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { StatementOfAccountForm } from '@/components/forms/StatementOfAccountForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateSoaPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const location = useLocation()
  const paramsShippingLineId = useParams<{ shippingLineId: string }>().shippingLineId

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        selectedBookingIds?: number[]
        shippingLineName?: string
        shippingLineId?: string
        expectedDateFrom?: string
        expectedDateTo?: string
      }
    | null
  const selectedBookingIds = navigationState?.selectedBookingIds || []
  const shippingLineName = navigationState?.shippingLineName || ''
  const finalShippingLineId = navigationState?.shippingLineId || paramsShippingLineId
  const expectedDateFrom = navigationState?.expectedDateFrom
  const expectedDateTo = navigationState?.expectedDateTo

  const handleSuccess = () => {
    if (finalShippingLineId) navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    else navigate('/shipping-lines')
  }

  const handleCancel = () => {
    if (finalShippingLineId) navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    else navigate('/shipping-lines')
  }

  if (!finalShippingLineId) {
    return (
      <AdminLayout constrainedContent>
        <Box p={4}>
          <Text color={colors.textSecondary} mb={4}>
            Missing shipping line. Please go back and select a shipping line.
          </Text>
          <Button size="sm" variant="outline" onClick={() => navigate('/shipping-lines')}>
            Back to Shipping Lines
          </Button>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout constrainedContent>
      <Box
        p={4}
        minW={0}
        h="100%"
        overflow="auto"
        display="flex"
        flexDirection="column"
      >
        <VStack spacing={0} align="stretch" flex="1" minH={0} minW={0}>
          <Card minW={0}>
            <CardHeader>
              <Heading size="md" mb={1}>
                Create Statement of Account
              </Heading>
              <Text fontSize="sm" color={colors.text}>
                Create a new Statement of Account
              </Text>
            </CardHeader>
            <CardBody minW={0} overflow="visible">
              <StatementOfAccountForm
                shippingLineId={finalShippingLineId}
                shippingLineName={shippingLineName}
                selectedBookingIds={selectedBookingIds}
                expectedDateFrom={expectedDateFrom}
                expectedDateTo={expectedDateTo}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            </CardBody>
          </Card>
        </VStack>
      </Box>
    </AdminLayout>
  )
}

